export default __webpack_public_path__ + "static/media/skeleton-empty-img-lg.294d72ca.svg";